module.exports = __webpack_public_path__ + "static/media/2b Cuff Ankle.782ee91e.jpg";